import React, { useEffect, useState } from 'react';
import { useContracts } from '../../hooks/useContract';
import { formatUsdc, formatZenova, bnToNumber } from '../../utils/format';
import { InlineLoader } from '../common/Loader';

export const ContractStats = () => {
  const { viewsR } = useContracts();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!viewsR) return;
      try {
        const s = await viewsR.getContractStats();
        if (cancelled) return;
        setStats(s);
      } catch (e) {}
    };
    load();
    const t = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(t); };
  }, [viewsR]);

  if (!stats) return <InlineLoader text="Loading stats..." />;

  return (
    <div className="admin-form-grid">
      <div className="admin-metric">
        <div className="metric-label">Total Users</div>
        <div className="metric-value">{bnToNumber(stats.totalUsers)}</div>
      </div>
      <div className="admin-metric">
        <div className="metric-label">Active Users</div>
        <div className="metric-value">{bnToNumber(stats.activeUsers)}</div>
      </div>
      <div className="admin-metric">
        <div className="metric-label">Total Invested</div>
        <div className="metric-value">${formatUsdc(stats.totalInvestment)}</div>
      </div>
      <div className="admin-metric">
        <div className="metric-label">Contract USDC</div>
        <div className="metric-value">${formatUsdc(stats.usdcBalance)}</div>
      </div>
      <div className="admin-metric">
        <div className="metric-label">Contract ZENOVA</div>
        <div className="metric-value">{formatZenova(stats.zenovaBalance)}</div>
      </div>
    </div>
  );
};
